<div class="carousel-layout">
  <div class="carousel-wrapper">
    <div class="carousel-items-container" (swipeleft)="swipeLeft()" (swiperight)="swipeRight()" #carouselItemsContainer>
      <ng-content #items />
    </div>
  </div>
  @if (itemsLength > 1 && !hideIndicators) {
    <div class="pt-2">
      <cui-carousel-indicators
        (goToPage)="goToPage($event)"
        [variant]="variant"
        [setItemsLength]="itemsLength"
        [setCurrentPage]="currentPage" />
    </div>
  }
</div>
